import { createContextValue } from '@texas/utils/contextState';
import { useRef } from 'react';

export function usePortalRef() {
  const refValue = useRef<HTMLElement | null>(document.body);

  const bindRef = {
    ref: (r: any) => (refValue.current = r),
  };

  return { ref: refValue, bindRef };
}

export const [PortalRefProvider, usePortalRefValue] =
  createContextValue<ReturnType<typeof usePortalRef>>();
